import { Routes } from '@angular/router';
import { UserEmailVerify } from './components/user-email-verify/user-email-verify';
import { LoginUser } from './components/login-user/login-user';
import { LayoutPage } from './components/layout-page/layout-page';
import { UserProfile } from './components/user-profile/user-profile';
import { AccountInfo } from './components/account-info/account-info';
import { AccountSubscriptions } from './components/account-subscriptions/account-subscriptions';
import { UsersList } from './components/users-list/users-list';
import { UserSessions } from './components/user-sessions/user-sessions';
import { Dashboard } from './components/dashboard/dashboard';
import { SetPassword } from './components/set-password/set-password';
import { authGuard } from './shared/guards/auth-guard';

export const routes: Routes = [
    { path: '', redirectTo: 'login-user', pathMatch: 'full' },
    { path: 'verify-email', component: UserEmailVerify },
    { path: 'login-user', component: LoginUser },
    { path: 'set-password', component: SetPassword },
    { path: 'app', component: LayoutPage, canActivate: [authGuard],
        children: [
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
            { path: 'dashboard', component: Dashboard },
            { path: 'profile', component: UserProfile },
            { path: 'account-info', component: AccountInfo },
            { path: 'subscriptions', component: AccountSubscriptions },
            { path: 'users', component: UsersList },
            { path: 'sessions', component: UserSessions }
        ]
    },
];
